// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/design-system/components/forms/TextInput.jsx

import React, { forwardRef } from "react";
import "./forms.css";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

const TextInput = forwardRef(function TextInput(
  { size = "medium", className = "", ...inputProps },
  ref
) {
  return (
    <input
      {...inputProps}
      ref={ref}
      className={joinClassNames(
        "oasys-control",
        "oasys-text-input",
        size !== "medium" && `oasys-control--${size}`,
        className
      )}
    />
  );
});

export default TextInput;
